/**
 * Liens vers les documents juridiques — MÊMES conventions que SEmplyApp
 * (apps/web/src/site/conditions.js) : les textes vivent sur le site vitrine,
 * les URLs sont configurables par les mêmes variables, et les deux produits
 * pointent donc vers les MÊMES documents. Pour changer un lien partout :
 * VITE_TERMS_URL / VITE_PRIVACY_URL dans chaque front, ou déplacer la page
 * sur le vitrine.
 */
const SITE_URL = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? 'https://semply.fr').replace(/\/$/, '');

/**
 * Les conditions générales d'utilisation et de vente : DOCUMENT UNIQUE de la
 * suite depuis le 02/10/2026 (les anciennes CGU du site, /cgu, y redirigent).
 */
export const TERMS_URL =
  (import.meta.env.VITE_TERMS_URL as string | undefined) ?? `${SITE_URL}/cgv`;
export const PRIVACY_URL =
  (import.meta.env.VITE_PRIVACY_URL as string | undefined) ?? `${SITE_URL}/confidentialite`;
